import React from 'react';
const steps = [{
  step: 1,
  text: 'Descargas el pack (acceso inmediato).'
}, {
  step: 2,
  text: 'Empiezas por Tomo 1 (20 palabras + 5 frases).'
}, {
  step: 3,
  text: 'Día 2 agregas expresiones (Tomo 2).'
}, {
  step: 4,
  text: 'Día 3 refuerzas con historia o cancionero.'
}, {
  step: 5,
  text: 'Sigues el Planner 30 días (Bono #2) para no abandonar.'
}];
export function HowToStart() {
  return <section className="w-full bg-white py-8 md:py-14 px-4" data-id="element-87">
      <div className="max-w-3xl mx-auto" data-id="element-88">
        <h2 className="text-2xl md:text-4xl font-bold text-[#1A1A2E] text-center mb-6" data-id="element-89">
          ¿Cómo empiezas?
        </h2>

        <div className="space-y-3" data-id="element-90">
          {steps.map(item => <div key={item.step} className="flex items-center gap-4 bg-[#F8F9FA] p-4 rounded-xl" data-id="element-91">
              <div className="flex-shrink-0 w-12 h-12 bg-[#FF6B00] text-white rounded-full flex items-center justify-center font-bold text-xl" data-id="element-92">
                {item.step}
              </div>
              <p className="text-lg text-[#4A4A5A]" data-id="element-93">
                <span className="font-semibold text-[#1A1A2E]" data-id="element-94">
                  Paso {item.step}:
                </span>{' '}
                {item.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}